// assets provider
import React, { createContext, useContext } from 'react';

import { useIndex } from '../hooks';
import { NewWillContext } from '../pages/new-will';

export const AssetsContext = createContext({ assets: [], loading: false, update: () => {} });

export function AssetsProvider({ children }) {
  const { will } = useContext(NewWillContext);
  const { data, loading, update } = useIndex('assets', { will_id: will.id });

  if (loading) {
    return <div>Loading assets...</div>;
  }

  return (
    <AssetsContext.Provider value={{ assets: data || [], loading, update }}>
      {children}
    </AssetsContext.Provider>
  );
}